import * as React from "react";

interface SVGRProps {
	title?: string;
	titleId?: string;
}
function SvgContainerAutomate({
	title,
	titleId,
	...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
	return (
		<svg
			width={32}
			height={32}
			viewBox="0 0 32 32"
			xmlns="http://www.w3.org/2000/svg"
			aria-labelledby={titleId}
			{...props}
		>
			{title ? <title id={titleId}>{title}</title> : null}
			<path d="M14.901 20.492c0 .433.506.805 1.104.805.598 0 1.103-.372 1.103-.805v-1.031h9.551v4.703c0 1.578-1.423 2.867-3.166 2.867H8.518c-1.754 0-3.167-1.289-3.167-2.867v-4.703h9.55v1.031Zm-7.488 3.683c0 .433.507.803 1.105.803h14.975c.598 0 1.103-.37 1.104-.803v-2.64h-5.642c-.464 1.072-1.609 1.835-2.96 1.835-1.35 0-2.496-.763-2.96-1.836H7.413v2.64ZM22.111 4c.34 0 .66.145.877.382l3.671 4.125c.217.247.34.598.341.99v5.498c0 1.702-1.269 2.754-2.444 2.754H7.444C6.27 17.749 5 16.697 5 14.995V9.497c0-.381.124-.732.34-.98l3.672-4.135c.216-.248.536-.382.877-.382H22.11ZM7.67 9H9a1 1 0 0 1 0 2H7.062v4.005c0 .505.31.691.382.691h17.112c.082 0 .381-.176.381-.691V11H23a1 1 0 1 1 0-2h1.33L21.72 6.062H10.28L7.67 9Zm11.3-1.88a1 1 0 0 1 1.53 1.29l-5.053 6a1 1 0 0 1-1.507.025l-2.166-2.4a1 1 0 1 1 1.485-1.34l1.397 1.548 4.315-5.123Z" />
		</svg>
	);
}

const MemoSvgContainerAutomate = React.memo(SvgContainerAutomate);
export default MemoSvgContainerAutomate;
